module.exports = __webpack_public_path__ + "img/edit.19d282ba.png";